import { VChip } from 'vuetify/lib/components/VChip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VChip,
    {
      staticClass: "filter-button",
      class: { "filter-button_small": _vm.small },
      attrs: {
        color: _vm.isActive ? "primary" : "bg-primary",
        "text-color": _vm.isActive ? "bg-gray-0" : "primary",
        close: _vm.isActive,
        "close-icon": "ui-icon-close-circle",
      },
      on: { click: _vm.handleClick, "click:close": _vm.resetHandler },
    },
    [
      _vm.icon
        ? _c("span", { staticClass: "mr-2", class: _vm.icon })
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "text-body-1" }, [
        _vm._v("\n    " + _vm._s(_vm.label) + "\n    "),
        _vm.isActive
          ? _c("span", [
              _vm._v("\n      (" + _vm._s(_vm.activeNum) + ")\n    "),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }